import { render, staticRenderFns } from "./ChatMensagens.vue?vue&type=template&id=7bb883a9&scoped=true"
import script from "./ChatMensagens.vue?vue&type=script&lang=js"
export * from "./ChatMensagens.vue?vue&type=script&lang=js"
import style0 from "./ChatMensagens.vue?vue&type=style&index=0&id=7bb883a9&prod&lang=scss&scoped=true"
import style1 from "./ChatMensagens.vue?vue&type=style&index=1&id=7bb883a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb883a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VForm,VIcon,VProgressCircular,VTextarea})
